import React, { useState, useEffect } from "react";
import { Form , Button , Radio ,Row ,Col , DatePicker , Checkbox, message , Typography , Table } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { getRangeOptions } from './reports.module';
import { fetchTripsByBookingDate , fetchTripsByTravelDate, fetchExpenseReport} from '../../actions/reports.action';
import { getExpenseConfigByOperatorCode } from '../../actions/expense-config.actions';
import { expenseConfigSelector, expenseTypesSelector } from '../../selector/expense-config.selector';
import { getAPIDateFormat, getLocalDateAndTime, getUIDateFormat} from '../../utils/date.utils';
import { ScheduleSelect } from '../../components/search-components/schedule-select/schedule-select.component';
import { isValid, isValidArray, isValidNumber } from "../../utils/utilities";
import { roundNumber } from '../../utils/math.utils';
import { Printer } from '../../components/custom-components/custom-component';
import moment from 'moment';
import './expense.report.scss';

const {Text} =Typography;

const { RangePicker } = DatePicker;
let allowedMaxDaysRange=31;
let xs=24, sm=24, md=12 , lg=12 , xl=12 , xxl=12;


const getTripIds=(trips,isSelectAll,scheduleId)=>{
        let tripIds=[];
        if(isValidArray(trips)&&trips.length>0){
            trips.forEach(element => {
                if(isSelectAll){
                    tripIds.push(element.id);
                }else if(scheduleId===element.schedule_id){
                    tripIds.push(element.id);
                }
            });
        }

        return tripIds;
}



// Map expense type keys to form field names
const getFormFieldName = (expenseKey) => {
    const fieldMap = {
        'bata': 'bata',
        'toll': 'toll',
        'pooja': 'pooja',
        'bus_expenses': 'bus_expense',
        'parking': 'parking_expense',
        'driver': 'driver_expense',
        'attender': 'attender_expense',
        'grease_and_air': 'grease_and_air_expense',
        'misc': 'misc'
    };
    return fieldMap[expenseKey] || expenseKey;
};

const RenderReport=({expenseReport, fromDate, toDate, isBookingDate, expenseTypes, expenseConfig})=>{
    
    // Build columns dynamically based on expense config
    const buildColumns = () => {
        const columns = [
            {
                title:"Trip Start Date",
                key:"date",
                dataIndex:"date",
                sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix()
            }
        ];

        if (!expenseTypes || !expenseConfig) {
            return columns;
        }

        // Get expense type keys and filter by config
        const expenseTypeKeys = Object.keys(expenseTypes);
        const visibleExpenseTypes = expenseTypeKeys.filter(key => {
            return expenseConfig[key] === 1;
        });

        // Sort by order property
        const sortedExpenseTypes = visibleExpenseTypes.sort((a, b) => {
            const orderA = expenseTypes[a]?.order || 0;
            const orderB = expenseTypes[b]?.order || 0;
            return orderA - orderB;
        });

        // Add expense columns
        sortedExpenseTypes.forEach(expenseKey => {
            const expenseType = expenseTypes[expenseKey];
            const fieldName = getFormFieldName(expenseKey);
            columns.push({
                title: expenseType.label,
                key: fieldName,
                dataIndex: fieldName
            });
        });

        // Add Total column
        columns.push({
            title:"Total",
            key:"total",
            dataIndex:"total",
            render : (text, record, index) => {
                let total = 0;
                sortedExpenseTypes.forEach(expenseKey => {
                    const fieldName = getFormFieldName(expenseKey);
                    total += (record[fieldName] || 0);
                });
                return roundNumber(total);
            }
        });

        return columns;
    };

    const columns = buildColumns();
    return(
        <div className="expense-report-container">
            <Row justify="center" gutter={[16,16]}>
                <Col>
                    <Text strong>Expense report</Text>
                </Col>
            </Row>
            <Row gutter={[16,0]} justify={"space-between"}>
                <Col  xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                    <Text>
                        <Text strong>From date : </Text>{fromDate}
                    </Text>
                </Col>
                <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                    <Text>
                        <Text strong>To date : </Text>{toDate}
                    </Text>
                </Col>
            </Row>
            <Row gutter={[16,0]} justify={"space-between"}>
                <Col  xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                    <Text>
                        <Text strong>Type of date : </Text>{isBookingDate?"Booking Date":"Travel Date"}
                    </Text>
                </Col>
                <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                    <Text>
                            <Text strong>Generated day/time : </Text>{getLocalDateAndTime(new Date())}
                    </Text> 
                </Col>
            </Row>
           <Row gutter={[16,16]} className="marginTop">
               <Col>
                    <Table 
                        columns={columns}
                        dataSource={expenseReport}
                        className="bordered-table"
                        pagination={false}
                        summary={(pageData) => {
                            if (!expenseTypes || !expenseConfig) {
                                return null;
                            }

                            // Get visible expense types sorted by order
                            const expenseTypeKeys = Object.keys(expenseTypes);
                            const visibleExpenseTypes = expenseTypeKeys.filter(key => {
                                return expenseConfig[key] === 1;
                            });
                            const sortedExpenseTypes = visibleExpenseTypes.sort((a, b) => {
                                const orderA = expenseTypes[a]?.order || 0;
                                const orderB = expenseTypes[b]?.order || 0;
                                return orderA - orderB;
                            });

                            // Initialize totals object
                            const totals = {};
                            sortedExpenseTypes.forEach(expenseKey => {
                                const fieldName = getFormFieldName(expenseKey);
                                totals[fieldName] = 0;
                            });

                            // Calculate totals
                            pageData.forEach(element => {
                                sortedExpenseTypes.forEach(expenseKey => {
                                    const fieldName = getFormFieldName(expenseKey);
                                    if(isValidNumber(element[fieldName])){
                                        totals[fieldName] += element[fieldName];
                                    }
                                });
                            });

                            // Calculate grand total
                            let grandTotal = 0;
                            Object.values(totals).forEach(total => {
                                grandTotal += total;
                            });

                            return (
                                <Table.Summary.Row style={{ backgroundColor: '#f0f2f5', fontWeight: 'bold', borderTop: '1px solid #d9d9d9' }}>
                                    <Table.Summary.Cell>Total</Table.Summary.Cell>
                                    {sortedExpenseTypes.map(expenseKey => {
                                        const fieldName = getFormFieldName(expenseKey);
                                        return (
                                            <Table.Summary.Cell key={fieldName}>
                                                {roundNumber(totals[fieldName])}
                                            </Table.Summary.Cell>
                                        );
                                    })}
                                    <Table.Summary.Cell>{roundNumber(grandTotal)}</Table.Summary.Cell>
                                </Table.Summary.Row>
                            )
                        }}
                    />
               </Col>
           </Row>
        </div>
    )
}

export const ExpenseReport = () => {

    const [form] = Form.useForm();
    const [scheduleForm] = Form.useForm();
    const dispatch = useDispatch();

    const expenseConfig = useSelector(expenseConfigSelector);
    const expenseTypes = useSelector(expenseTypesSelector);

    const [schedules,setSchedules]=useState(undefined);
    const [trips,setTrips]=useState(undefined);
    const [showReport,setShowReport]=useState(false);
    const [expenseReport,setExpenseReport]=useState(undefined);

    // Fetch expense config if not present
    useEffect(() => {
        if (!expenseConfig && !expenseTypes && global.operatorCode) {
            dispatch(getExpenseConfigByOperatorCode(global.operatorCode));
        }
    }, [expenseConfig, expenseTypes, dispatch]);

    const onSuccess=(data)=>{
        setSchedules(data.schedules);
        setTrips(data.trips);
    }

    const onFailure=()=>{
        setSchedules(undefined);
    }

    const onFinish=(values)=>{
        let {
            dateRange,
            isBooking
        }=values;
        const fromDate = getAPIDateFormat(dateRange[0]);
        const toDate = getAPIDateFormat(dateRange[1]);
        setShowReport(false);
        if(isBooking){
            fetchTripsByBookingDate(fromDate,toDate,onSuccess,onFailure);
        }else{
            fetchTripsByTravelDate(fromDate,toDate,onSuccess,onFailure);
        }
    }

    return (
            <div className="report-inner-div">
                <Form
                    onFinish={onFinish}
                    form={form}
                    >
                    <Row gutter={[16,16]}>
                        <Col>
                            <Form.Item name="dateRange" label="Date range" 
                               rules={[
                                { required: true , message: 'Please input your date range!'},
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      if (!value || (value[1].diff(value[0],"days") <= allowedMaxDaysRange)) {
                                        return Promise.resolve();
                                      }
                                      return Promise.reject(new Error(`Please select a date range with in ${allowedMaxDaysRange} days`));
                                    },
                                  })
                            ]}>
                                    <RangePicker 
                                        ranges={getRangeOptions(allowedMaxDaysRange)} 
                                    />
                            </Form.Item>
                        </Col>
                        <Col>
                        <Form.Item name="isBooking" label="" rules={[{ required: true , message: 'Please select any option!'}]}>
                            <Radio.Group>
                                <Radio value={true}>Booking Date</Radio>
                                <Radio value={false}>Travel Date</Radio>
                            </Radio.Group>
                        </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item>
                                <Button htmlType="submit">Search</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                {isValidArray(schedules)&&
                        <Form
                        form={scheduleForm}
                        initialValues={{isSelectAllSchedules:false}}
                        onFinish={(values)=>{
                            let {
                                returnId,
                                isSelectAllSchedules
                            }=values;
                            setShowReport(false);
                            if(isValid(returnId)||isSelectAllSchedules){                                
                                    let selectedTripIds = getTripIds(trips,isSelectAllSchedules,returnId);
                                fetchExpenseReport(selectedTripIds,(data)=>{
                                    setExpenseReport(data);
                                    setShowReport(true);
                                },()=>{});
                            }else{
                                message.error("Select schedule!");
                            }
                        }}
                        >
                            <Row gutter={[16,16]}>
                                <Col>
                                    <ScheduleSelect 
                                        schedules={schedules}
                                        optionKey="id"
                                        showLabel={true}
                                        isManditory={false}
                                    />
                                </Col>
                                <Col>
                                    <Form.Item name="isSelectAllSchedules"  valuePropName="checked">
                                        <Checkbox>All</Checkbox>
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item>
                                        <Button htmlType="submit">Get</Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                }

                {showReport&&
                <div>
                    <Row gutter={16}>
                        <Col>
                                <Printer 
                                    showComponent={false}
                                    // zoomValue={0.5}
                                    renderComponent={()=>{
                                        return (
                                            <RenderReport 
                                            expenseReport={expenseReport}
                                            fromDate={getUIDateFormat(form.getFieldValue('dateRange')[0])}
                                            toDate={getUIDateFormat(form.getFieldValue('dateRange')[1])}
                                            isBookingDate={form.getFieldValue('isBooking')}
                                            expenseTypes={expenseTypes}
                                            expenseConfig={expenseConfig}
                                        />
                                )
                            }} />
                        </Col>
                    </Row>
                    <RenderReport 
                        expenseReport={expenseReport}
                        fromDate={getUIDateFormat(form.getFieldValue('dateRange')[0])}
                        toDate={getUIDateFormat(form.getFieldValue('dateRange')[1])}
                        isBookingDate={form.getFieldValue('isBooking')}
                        expenseTypes={expenseTypes}
                        expenseConfig={expenseConfig}
                    />
                </div>
                }
            </div>
    )
}